import { ImageBackground, Pressable, ScrollView, View, Text ,Image} from 'react-native';
import { ThemedText, ThemedView, themeTextVariants } from '@app/theme';
import Button from '@app/sharedComponents/Button/Button';
import { formatIndianCurrency } from '@app/utils/utility';
import ROUTE from '@app/navigationApp/routes';
import {LENDER_DISPLAY_NAME_MAP} from '@app/constants/platformPartners';
import TataLogo from '../../../../assets/Icons/TataLogo';
import DSPLogo from '../../../../assets/Icons/DSPLogo';
import BajajLogo from '../../../../assets/Icons/BajajLogo';
const CreditInfoCard = ({isLoanExpiringToday,lendingPartnerId,creditInfo,navigation,pendingRequestInfo}) => {
    
    const {availableCreditAmount,principalOutStandingAmount} = creditInfo || {} ;

    const withdrawAction = ()=>{
      navigation.navigate(ROUTE.WITHDRAW_AMOUNT,{creditInfo})
    }

    const repayAction = ()=>{
      navigation.navigate(ROUTE.FLEXI_PAY,{creditInfo})
    }
    const logo = (id) => {
      const logoObj ={
      tata: <TataLogo/>,
      bajaj: <BajajLogo/>,
      dsp: <DSPLogo/>,
      }
      return logoObj[id]
  }
    const imageUrl = lendingPartnerId === 'DSP' ? 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/dsp_round_bg.png' : 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/bajaj_round_bg.png';
    return(
        <>
         <ThemedView mx='lg' mt='2xl' borderColor='border-primary' backgroundColor='bg-surface-primary' borderWidth={1} borderRadius='lg' style={[]} >
    				<Image style={{ height: 96, width: 140, position: 'absolute' , right : 0, top:0, borderTopRightRadius:16 }} source={{ uri: imageUrl }} />
              <ThemedView  p='lg'>
                <ThemedText color='text-secondary'  variant='b4r' pb='2xs' >
                  Available cash with {LENDER_DISPLAY_NAME_MAP[lendingPartnerId]}
                </ThemedText>
                <ThemedView  flexDirection='row' alignItems='center' pb='sm'>
                <ThemedText color='text-emphasis-secondary'  variant='l1'>₹</ThemedText>
                <ThemedText color='text-emphasis-secondary'  variant='h1b'>
                  {formatIndianCurrency(Math.floor(availableCreditAmount))}
                </ThemedText>
                </ThemedView>
              </ThemedView>
              <ThemedView p='lg' py="md" flexDirection='row' justifyContent='space-between' borderTopColor='border-primary' borderTopWidth={1}>
                <ThemedView>
                  <ThemedText color='text-secondary'  variant='b4r' pb='2xs'  >
                    Outstanding amount
                  </ThemedText>
                  <ThemedView flexDirection='row' alignItems='baseline' mb='sm'>
                    <ThemedText color='text-primary'  variant='l5'>₹</ThemedText>
                    <ThemedText color='text-primary'  variant='h5b'>
                    {formatIndianCurrency(principalOutStandingAmount??0)}
                    </ThemedText>
                  </ThemedView>
                </ThemedView>
                <ThemedView alignItems='flex-end'>
                  <ThemedText color='text-secondary' variant='b4r' mb="xs">Lender</ThemedText>
                  {logo(lendingPartnerId?.toLowerCase())}
                </ThemedView>
              </ThemedView>
            </ThemedView>
            <ThemedView px='lg' flex={1} flexDirection='row' justifyContent='space-between' alignItems='center' mt='md' width={'100%'}>
              <ThemedView pr='xs' width={'50%'}>
                <Button type="OUTLINED" label="Repay" handlePress={repayAction} disabled={principalOutStandingAmount<=0} />
              </ThemedView>
              <ThemedView  width={'50%'} pl='xs'>
                <Button type='SOLID' label='Withdraw' eventName="WITHDRAW_BUTTON" handlePress={withdrawAction} disabled={pendingRequestInfo?.disbursalDetailsList?.length>0 || pendingRequestInfo?.renewalRequestDetailsList?.length>0 || availableCreditAmount<=0 || isLoanExpiringToday } />
              </ThemedView>
            </ThemedView>
        </>
    )
}

export default CreditInfoCard;